// extracted by mini-css-extract-plugin
module.exports = {"iconaWrapper":"iconaMedia_iconaWrapper__Iwo_Z","enllacExtern3Cat":"iconaMedia_enllacExtern3Cat___hRuz"};